import { useQuery } from '../../../../ReactQuery';
import { get } from '../../../../redux/api';
import type {
  ListRepositoriesParams,
  ListRepositoriesResponse,
} from '../../../../../shared/types/routes/vcs/githubApp';
import type { VcsApp } from '../../../../../shared/vcs/githubApp/apps';

const fetchGitHubAppRepositories = (app: VcsApp, { page, pageSize, q, connectionId }: ListRepositoriesParams) =>
  get<ListRepositoriesResponse>(`/api/vcs/github-apps/${app}/repositories`, false, {
    page,
    pageSize,
    q,
    connectionId,
  });

export const getGitHubAppRepositoriesQueryKeyPrefix = (app: VcsApp) =>
  ['vcs', 'github-apps', app, 'repositories'] as const;

export const getGitHubAppRepositoriesQueryKey = (app: VcsApp, params: ListRepositoriesParams) =>
  [...getGitHubAppRepositoriesQueryKeyPrefix(app), params] as const;

/**
 * Lists a page of repositories for the org's `app` connection, with server-side pagination
 * and name search (mirroring the legacy import flow).
 * Pass `enabled: false`: before the app is installed, hold the request until the org has a connection.
 *
 * Keeps the previous page on screen while the next page/search loads, so the table paginates
 * without flashing the loader between pages.
 */
export function useGitHubAppRepositories(
  app: VcsApp,
  params: ListRepositoriesParams,
  { enabled = true }: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: getGitHubAppRepositoriesQueryKey(app, params),
    queryFn: () => fetchGitHubAppRepositories(app, params),
    enabled,
    // Keeps previous data visible while fetching next page
    keepPreviousData: true,
  });
}
